<template>
  <div>
    <div
      class="wizard flex flex-col lg:flex-row justify-center px-5 sm:px-20"
    >
      <div
        class="intro-x lg:text-center flex items-center lg:block flex-1 z-10 lg:mt-0"
        :class="{'mt-5':key>0}"
        v-for="(header, key) in headerStep"
        :key="key"
      >
        <div class="relative">
          <button
            class="w-10 h-10 rounded-full btn"
            :class="[header.step==currentStep||allSaveStep.includes(header.step)? 'btn-primary' : 'text-gray-600 bg-gray-200 dark:bg-dark-1']"
          >
            {{ header.step }}
          </button>
          <div class="w-4 h-4 flex items-center justify-center absolute rounded-full text-white bg-theme-10 bottom-0 -mr-2 -mt-2" style="left:53%" v-show="allSaveStep.includes(header.step)">
            <CheckIcon class="w-3 h-3 text-white"/>
          </div>
        </div>
        <div class="lg:w-32 font-medium text-base lg:mt-3 ml-3 lg:mx-auto">
          {{ header.title }}
        </div>
      </div>
      <div
        class="wizard__line hidden lg:block w-2/3 bg-gray-200 dark:bg-dark-1 absolute mt-5"
      />
    </div>
    <step-1 :form-search="formModal" :update-id="updateId" :class="[currentStep == 1? 'block':'hidden']" @next-step="getNextStepOneVal($event)" @skip-step="getSkipStepVal($event)" @close-wizard="closeWizardForm($event)" @prev-step="getPrevStepVal($event)" />
    <step-2 :update-id="updateId" :class="[currentStep == 2? 'block':'hidden']" @next-step="getNextStepVal($event)" @skip-step="getSkipStepVal($event)" @close-wizard="closeWizardForm($event)" @prev-step="getPrevStepVal($event)" />
    <step-3 :update-id="updateId" :national-id="memberNationalId" :class="[currentStep == 3? 'block':'hidden']" @next-step="getNextStepVal($event)" @skip-step="getSkipStepVal($event)" @close-wizard="closeWizardForm($event)" @prev-step="getPrevStepVal($event)" />
    <step-4 :update-id="updateId" :class="[currentStep == 4? 'block':'hidden']" @next-step="getNextStepVal($event)" @skip-step="getSkipStepVal($event)" @close-wizard="closeWizardForm($event)" @prev-step="getPrevStepVal($event)" />
    <step-5 :update-id="updateId" :class="[currentStep == 5? 'block':'hidden']" @skip-step="getSkipStepVal($event)" @close-wizard="closeWizardForm($event)" @prev-step="getPrevStepVal($event)" />
    <FindCitizenModal @updateForm="getFormvalue($event)"/>
  </div>
</template>

<script>
import { ref, defineComponent, reactive, computed } from 'vue'
import step1 from './step-1/index.vue'
import step2 from './step-2/index.vue'
import step3 from './step-3/index.vue'
import step4 from './step-4/index.vue'
import step5 from './step-5/index.vue'
import Swal from 'sweetalert2'
import { useRouter } from 'vue-router'
import FindCitizenModal from "./container/FindCitizenModal.vue"
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})
export default defineComponent ({
  components: { step1, step2, step3, step4, step5, FindCitizenModal },
    setup(){
        const headerStep = reactive(
          [
            {
              title: "ข้อมูลพื้นฐาน",
              step: 1
            },
            {
              title: "รายได้",
              step: 2
            },
            {
              title: "สุขภาพ",
              step: 3
            },
            {
              title: "สวัสดิการ",
              step: 4
            },
            {
              title: "สภาพปัญหา",
              step: 5
            }
          ]
        )
        const currentStep = ref(1)
        const saveStep = ref(0)
        const allSaveStep = reactive([])
        const router = useRouter()
        const formModal = ref({})
        const updateId = ref()
        const memberNationalId = ref("")
        function getPrevStepVal(val){
          window.scrollTo(0,0);
          currentStep.value = val - 1
        }
        function getSkipStepVal(val){
          window.scrollTo(0,0);
          currentStep.value = val + 1
        }
        function closeWizardForm(val){
          const result = headerStep.find( ({ step }) => step === saveStep.value + 1 );
          swalCustom.fire({
            html:"<div>ข้อมูล"+result.title+"จะไม่ถูกบันทึก</div>\
            <div>คุณแน่ใจที่จะออกจากหน้านี้</div>",
            icon:"warning",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then(async(result) => {
            if (result.isConfirmed) {
              //รอให้ SweetAlert2 animation ปิดหมด (300ms สำหรับ closing animation)
              await new Promise(resolve => setTimeout(resolve, 400));
              //ตรวจสอบว่า SweetAlert2 ปิดหมดแล้ว
              let checkCount = 0;
              const checkInterval = setInterval(() => {
                checkCount++;
                if (!Swal.isVisible() || checkCount >= 10) {
                  clearInterval(checkInterval);
                  //Navigate หลังจากแน่ใจว่า SweetAlert2 ปิดหมดแล้ว
                  router.go(-1);
                }
              }, 50);
              //Fallback: ถ้า 500ms แล้วยังไม่ได้ navigate ให้ navigate เลย
              setTimeout(() => {
                clearInterval(checkInterval);
                if (Swal.isVisible()) {
                  Swal.close();
                }
                router.go(-1);
              }, 500);
            }
          })
        }
        function getNextStepOneVal(val){
          window.scrollTo(0,0);
          currentStep.value  = val.current + 1
          if(!allSaveStep.includes(val.current)){
            saveStep.value = val.current
            allSaveStep.push(saveStep.value)
          }
          updateId.value = val.update_id
          memberNationalId.value = val.national_id ?? ""
        }
        function getNextStepVal(val){
          window.scrollTo(0,0);
          currentStep.value  = val + 1
          if(!allSaveStep.includes(val)){
            saveStep.value = val
            allSaveStep.push(saveStep.value)
          }
        }
        function getFormvalue(val){
          formModal.value = val
        }

        // const plusOne = computed(() => currentStep.value + 1)
        return {
            getPrevStepVal,
            getSkipStepVal,
            closeWizardForm,
            headerStep,
            currentStep,
            saveStep,
            allSaveStep,
            getNextStepVal,
            getFormvalue,
            formModal,
            updateId,
            memberNationalId,
            getNextStepOneVal
        }
    }
})
</script>

<style>

</style>